/* Harmony Modern PDF pagination; real PDF pages retain their own numbers. */
(function (root) {
  function pages(total) {
    var result = [];
    for (var i = 1; i <= total; i++) {
      if (i === total && total > 1 && total % 2 === 1) result.push(0);
      result.push(i);
    }
    return result;
  }
  function view(index, mapping, portrait) {
    var last = mapping.length - 1;
    var cover = index === 0 || index === last;
    var nums = portrait || cover ? [mapping[index]] : mapping.slice(index, index + 2).filter(Boolean);
    return { numbers: nums, offset: portrait || !cover ? 0 : (index === 0 ? -.5 : .5), first: index === 0, last: index === last };
  }
  var api = { pages: pages, view: view };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.HarmonyPdfBook = api;
})(typeof window === 'object' ? window : globalThis);
